import { z } from 'zod';

export function mergeSchemas(...schemas: z.ZodType[]): z.ZodType {
  return z.any().superRefine((data, ctx) => {
    for (const schema of schemas) {
      const result = schema.safeParse(data);
      if (!result.success) {
        for (const issue of result.error.issues) {
          ctx.addIssue(issue);
        }
      }
    }
  });
}
